import React from 'react'
import { MenuItem, TextField } from '@mui/material'

/**
 * Duration slicer — All / Short / Long.
 *
 * Drives the Short/Long filter for Revenue, Cancellation Rate and
 * Booking Pace. Boundary (days) is configurable per tenant via D9
 * (admin/checkout-config). Backend resolves the threshold; this picker
 * only emits the mode.
 *
 *   value     = 'total' | 'short' | 'long'
 *   onChange(value, { intent: 'instant' })  — single-choice → apply now
 */
export default function DurationSlicer({ value, onChange }) {
	return (
		<TextField select size="small" label="Duration"
		           value={value || 'total'}
		           onChange={(e) => onChange(e.target.value, { intent: 'instant' })}
		           sx={{ minWidth: 140 }}>
			<MenuItem value="total">All</MenuItem>
			<MenuItem value="short">Short</MenuItem>
			<MenuItem value="long">Long</MenuItem>
		</TextField>
	)
}
